import { FC } from 'react'
import { AtendimentoView } from '../../modules/apps/atendimento/core/_models'

type IInfoAtendimento = {
  className?: string
  atendimento: AtendimentoView
}

export const InfoAtendimento: FC<IInfoAtendimento> = ({ className = '', atendimento }) => {
  return (
    <>
      {atendimento && (
        <div className={`${className} mb-5`}>
          <span className='indicator-progress fw-bold' style={{ display: 'block' }}>
            Protocolo de atendimento: {atendimento?.protocolo} <br />
            Estado: {atendimento?.estado?.descricao}
          </span>
          <span className='fw-bold text-success' style={{ display: 'block' }}>
            Atendimento Solicitado! Acesse a lista de atendimentos para acompanhá-lo.
          </span>
        </div>
      )}
    </>
  )
}
